import React from "react";
import { withFormik } from "formik";
import { FormikPropTypes } from "../../../forms/helpers/formikPropTypes";
import CompanySelector from "../../../forms/reusable/companySelector";
import CustomTypeahead from "../../../forms/fields/CustomTypeahead";
import { getCrewMembers } from "../../../../services/api/crewMembers";
import {
  generateVouchers,
  getRegistrations
} from "../../../../services/api/registrations";
import PropTypes from "prop-types";
import {
  ajaxErrorHandler,
  defaultError,
  defaultSuccess,
  getPrinterForDayPeriod
} from "../../../../libs/utils";
import {
  getAccessVouchers,
  redeemAccessVoucher,
  reprintAccessVoucherWristband
} from "../../../../services/api/accessVouchers";
import ListView from "../../../../base/ListView";
import { toImmutable } from "../../../../libs/immutable-transformer";
import { printZPL } from "../../../../services/printer";
import { Base64 } from "js-base64";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      crewmembers: [],
      registrationId: undefined,
      vouchers: [],
      vouchersMeta: {}
    };

    this._handleCrewMemberSearch = this._handleCrewMemberSearch.bind(this);
    this._handleNewCrewMember = this._handleNewCrewMember.bind(this);
    this._loadVouchers = this._loadVouchers.bind(this);
    this._redeem = this._redeem.bind(this);
    this._reprint = this._reprint.bind(this);
    this._generate = this._generate.bind(this);
  }

  static propTypes = {
    event: PropTypes.object,
    ...FormikPropTypes
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.values.companyId !== nextProps.values.companyId &&
      nextProps.values.companyId
    ) {
      getRegistrations({
        "filter[event_id]": this.props.event.id,
        "filter[company_id]": nextProps.values.companyId
      }).then(response => {
        if (response.data.length > 0) {
          this.setState({
            registrationId: response.data[0].id
          });
        } else {
          defaultError(
            "This company is not working on " + this.props.event.name
          );
          this.props.setFieldValue("companyId", "");
        }
      });
    }

    if (
      this.props.values.companyId !== nextProps.values.companyId &&
      !nextProps.values.companyId
    ) {
      this.setState({
        registrationId: undefined
      });
    }
  }

  _handleCrewMemberSearch(value) {
    getCrewMembers({
      "filter[registration_id]": this.state.registrationId,
      "filter[name_like]": value,
      include: "user"
    }).then(response => {
      this.setState({
        crewmembers: response.data
      });
    });
  }

  _handleNewCrewMember(values) {
    if (values.length > 0) {
      this.props.setFieldValue("crewMemberId", values[0].id);
      this.setState({
        latestCrewMember: values[0]
      });
      this._loadVouchers(values[0]);
    } else {
      this.props.setFieldValue("crewMemberId", "");
    }
  }

  _loadVouchers(crewMember) {
    this.setState({
      loading: true
    });

    getAccessVouchers(this.state.registrationId, {
      "filter[user_name]":
        crewMember.user.firstName + " " + crewMember.user.lastName,
      include:
        "crew-member,crew-member.user,access-voucher-template,access-voucher-template.period,access-voucher-template.profile-group"
    })
      .then(response => {
        this.setState({
          vouchers: response.data,
          vouchersMeta: response.meta,
          loading: false
        });
      })
      .catch(ajaxErrorHandler);
  }

  _generate() {
    generateVouchers(this.state.registrationId, {
      priority: true,
      crewMemberId: this.props.values.crewMemberId,
      sendVouchers: false
    })
      .then(reponse => {
        defaultSuccess(
          "Vouchers are being generated, please give the server a few seconds."
        );
        for (let i = 1; i <= 10; i++) {
          setTimeout(
            () => this._loadVouchers(this.state.latestCrewMember),
            i * 1000
          );
        }
      })
      .catch(ajaxErrorHandler);
  }

  _redeem(item) {
    const day = item.accessVoucherTemplate.day
      ? item.accessVoucherTemplate.day
      : "combi";
    const period = item.accessVoucherTemplate.period;

    getPrinterForDayPeriod(day, period, this.props.printerSettings).then(
      printer => {
        redeemAccessVoucher(this.state.registrationId, item.id)
          .then(response => {
            const zpl = Base64.decode(response.zpl);
            printZPL(printer, zpl);
            defaultSuccess("Wristband Printed");
            this._load();
          })
          .catch(ajaxErrorHandler);
      }
    );
  }

  _reprint(item) {
    const day = item.accessVoucherTemplate.day
      ? item.accessVoucherTemplate.day
      : "combi";
    const period = item.accessVoucherTemplate.period;

    getPrinterForDayPeriod(day, period, this.props.printerSettings).then(
      printer => {
        reprintAccessVoucherWristband(this.state.registrationId, item.id)
          .then(response => {
            const zpl = Base64.decode(response.zpl);
            printZPL(printer, zpl);
            defaultSuccess("Wristband Printed");
            this._load();
          })
          .catch(ajaxErrorHandler);
      }
    );
  }

  render() {
    const props = this.props;
    const { crewmembers } = this.state;

    const { vouchers, vouchersMeta } = this.state;

    const listViewConf = {
      dataSet: vouchers,
      dataMeta: vouchersMeta,
      columns: [
        {
          key: "crewMemberId",
          value: "Crew Member",
          render: item =>
            item.crewMember.user.firstName + " " + item.crewMember.user.lastName
        },
        {
          key: "period",
          value: "Period",
          render: item => item.accessVoucherTemplate.period.name
        },
        {
          key: "day",
          value: "Day",
          render: item =>
            item.accessVoucherTemplate.day
              ? item.accessVoucherTemplate.day
              : "Combi"
        },
        {
          key: "redeemed",
          value: "Redeemed",
          render: item => (item.redeemedAt ? item.redeemedAt : "")
        }
      ],
      filters: [],
      baseFilters: toImmutable({}),
      actions: {
        deleteLink: false,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete,
        customLink: item => (
          <span>
            {!item.redeemedAt && (
              <button
                className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
                onClick={() => this._redeem(item)}
              >
                <span>
                  <i className="la la-print" />
                  <span>Print</span>
                </span>
              </button>
            )}
          </span>
        )
      },
      url: ""
    };

    return (
      <form className="m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <input type="hidden" name="id" />

          <CompanySelector {...props} name="companyId" />

          {props.values.companyId && (
            <CustomTypeahead
              name="crewMemberId"
              label="Crew Member"
              multiple={false}
              options={crewmembers}
              placeholder="Choose a company"
              labelKey={item => item.user.firstName + " " + item.user.lastName}
              onSearch={this._handleCrewMemberSearch}
              onChange={this._handleNewCrewMember}
              {...this.props}
            />
          )}

          {props.values.crewMemberId && (
            <div>
              <div className="row">
                <div className="col-xl-12 m--align-right">
                  <button
                    type="button"
                    className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                    onClick={this._generate}
                  >
                    <span>
                      <i className="la la-file-pdf-o" />
                      <span>Re-Generate</span>
                    </span>
                  </button>
                </div>
              </div>
              <ListView config={listViewConf} handleFilterUpdate={this.load} />
            </div>
          )}
        </div>
      </form>
    );
  }
}

const BoxOfficeSearchForm = withFormik({
  mapPropsToValues: props => {
    let values = {
      companyId: ""
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.barcode || values.barcode === "") {
      errors.barcode = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props, resetForm }) => {
    props
      .onSubmit(values)
      .then()
      .catch()
      .then(reponse => {
        resetForm();
        document.querySelector("input[name=barcode]").focus();
      });
  }
})(InnerForm);

export default BoxOfficeSearchForm;
